import 'featherlight';
import './../../node_modules/featherlight/src/featherlight.gallery.js';
//import Instafeed from 'instafeed.js';
import './../../node_modules/bootstrap-sass/assets/javascripts/bootstrap.js';
import './../../node_modules/lazyloadxt/src/jquery.lazyloadxt.js';
import './../../node_modules/lazyloadxt/src/jquery.lazyloadxt.video.js';
import 'slick-carousel';
import axios from 'axios';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

(function($) {
	$(document).ready(function() {
		window.profetCapiTracking = {
			init: function() {
				this.trackPageView();
				this.maybeTrackPageViewTreatment();
			},

			/* Track page views in Facebook Conversion API */
			trackPageView: function() {
				var sourceUrl = window.location.href;
				axios
					.get('/wp-json/nk/capi/pageView?sourceUrl=' + sourceUrl)
					.then((response) => {})
					.catch((error) => {});
			},
			maybeTrackPageViewTreatment() {
				/* Track page views in Facebook Conversion API */
				if (window.treatmentName) {
					var sourceUrl = window.location.href;
					axios
						.get('/wp-json/nk/capi/pageViewTreatment?sourceUrl=' + sourceUrl + '&treatmentName=' + window.treatmentName)
						.then((response) => {})
						.catch((error) => {});
				}
			},
		};

		window.profetCapiTracking.init();
	});
})(jQuery);
